/**
 * Error that is thrown when the fit test does not have a related person.
 */
export class ImportError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ImportError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
